export default "__VITE_ASSET__mRLtn0sm__"